<template>
  <main id="view-search-machines-results" class="products-results-view">
    <div class="search-title">
      <router-link :to="{path: '/search'}" class="icon-arrow-left"></router-link>
      <span class="text">{{ $t($route.meta.landingType) }}</span>
    </div>


    <div class="results-header">
      <div class="results-count text-desktop" v-if="filteredResults.length > 0">
        {{ $tc('results_count', filteredResults.length) }}
      </div>
      <div class="results-count text-mobile" v-if="filteredResults.length > 0">
        {{ $tc('results_count', filteredResults.length) }}
      </div>
      <div class="no-results" v-else>
        <span class="text">{{ $tc('results_count', 0) }}</span>
        <span class="subtext">{{ $t('please_enlarge_your_filter') }}</span>
      </div>

      <b-select
          v-model="category"
          class="categoryFilters"
          size="is-large" rounded

      >
        <option value="">{{ $t('filter_by_category') }}</option>
        <option :key="'machines'" :value="'machines'">{{ $t('all_machines') }}</option>
        <option :value="category.code" v-for="category in categoryFilters">{{ category.label }}</option>

      </b-select>

    </div>

    <div class="results" v-if="filteredResults && filteredResults.length > 0">
      <card-machine
          class="result-item"
          v-for="(result, index) in filteredResults"
          :key="result.identifier"
          :style="'order:'+index"
          :datas="result"
          :possibleAttributes="filtersSort"
          :class="{'is-bestseller': result.isBestSeller }"
      />
    </div>
  </main>
</template>


<script>
import {mapState, mapGetters} from 'vuex'
import stickyMixins from "@/common/mixins/sticky";
import filterMixins from "@/common/mixins/filters";

import productService from '@/services/serli/product'

import CardMachine from "@/components/Card/CardMachine.vue"
import {toggleBodyClass, triggerTrackingEvent} from "@/common/helpers";


export default {
  name: 'searchMachinesResults',
  mixins: [stickyMixins, filterMixins],
  components: {
    CardMachine
  },
  data() {
    return {
      results: [],
      possibleAttribute: [],
      resultsLoaded: false,
      resultsLoadedFirst: false,
      currentPage: 1,
      total: 0,
      sort: 'identifier/1',
      filtersSort: [],
      category: ''
    }
  },

  computed: {
    ...mapState({
      isLargeDesktop: state => state.settings.isLargeDesktop,
      isSmallDesktop: state => state.settings.isSmallDesktop,
      isTablet: state => state.settings.isTablet,
      isPhone: state => state.settings.isPhone,
      region: state => state.settings.region
    }),
    ...mapGetters({
      localeKebabFormat: 'settings/localeKebabFormat'
    }),
    itemsPerPage() {
      if (this.isLargeDesktop)
        return 20
      if (this.isSmallDesktop)
        return 16
      if (this.isTablet)
        return 12
      if (this.isPhone)
        return 10
      return 24;
    },

    categoryFilters() {
      var categoryFilters = []
      this.results.forEach((product) => {
        var productCategory = this.findBaseCategory(product.categories[0])
        if (!categoryFilters.find((x) => x.code === productCategory.code)) categoryFilters.push(this.findBaseCategory(product.categories[0]))
      })
      return categoryFilters;
    },

    filteredResults() {
      var filteredResults = [];
      if (this.category === 'machines' || this.category === '') return this.results;
      else {
        this.results.forEach((product) => {
          var productCategory = this.findBaseCategory(product.categories[0])
          if (productCategory.code === this.category) filteredResults.push(product)
        })
        return filteredResults;
      }
    }
  },
  created() {
    toggleBodyClass('removeClass', 'no-scroll');
    this.searchResults()
  },
  methods: {
    async searchResults() {
      var sort = this.sort.split('/')
      var landingParam = []
      this.startLoading()
      if (this.$route.meta.landingType === 'best_sellers') landingParam = {isBestSeller: true}
      if (this.$route.meta.landingType === 'new_products') landingParam = {isNew: true}
      if (this.$route.meta.landingType === 'low_emissions') landingParam = {isOxygen: true}

      this.resultsLoaded = false;

      productService.list(null, {
        ...landingParam,
        productType: 'machines',
        brand: this.$store.state.settings.brand,
        category: 'machines',
        full: false,
        //size: this.itemsPerPage,
        //page: this.currentPage,
        size: 999,
        page: 1,
        locale: this.localeKebabFormat,
        sortAttribute: sort[0],
        sortAsc: sort[1]

      })
          .then((response) => {
            if (response.data.code === 200) {
              this.total = response.data.data.length;
              //this.possibleAttribute = response.data.data.possibleAttributeValues;
              this.results = response.data.data;
              //if (this.$route.meta.landingType === 'best_sellers') {
              //  this.results=this.filterBestSellerByRegion(this.results)
              //}
              this.results.sort(function compare(a, b) {
                if (a.family.label < b.family.label)
                  return -1;
                if (a.family.label > b.family.label)
                  return 1;
              })
              if (this.new) this.results = response.data;
              if (this.results.total === 0) {
                /*gtag('event', 'result_no_machine_found', {
                  'event_category': 'result',
                  'event_label': "Affichage d'une page de résultat de recherche machines vide"
                });*/

                triggerTrackingEvent('result_no_machine_found', 'result', "Affichage d'une page de résultat de recherche machines vide")
              }
            }
          })
          .finally(() => {
            this.resultsLoaded = true;
            this.stopLoading()
          });
    },

    filterBestSellerByRegion(results) {
      let products = []
      let addProduct = false
      let attribute = null
      results.forEach((product) => {
        addProduct = false
        attribute = product.attributes.find(x => x.code === 'best_seller_region')
        if (attribute && attribute.value.label === 'R2') {
          addProduct = true
        } else {
          product.variants.forEach((variant) => {
            attribute = variant.attributes.find(x => x.code === 'best_seller_region')
            if (attribute && attribute.value.label === 'R2') {
              addProduct = true
            }
          })
        }
        if (addProduct) products.push(product)
      })

      return products;
    }


  }
}
</script>

<style lang="scss">
.categoryFilters {
  margin: 0;
  @media #{$mq_phone} {
    margin: 15px auto;
  }
}
</style>
